import React from 'react';
import { Icon } from 'elements';

const Facebook = ({size, className}) => (
  <Icon size={size} className={className}>
    <path d="M22.575,0H1.319C0.591,0,0,0.59,0,1.319v21.256c0,0.729,0.591,1.32,1.319,1.32h11.444v-9.253H9.649v-3.607h3.114
      v-2.66c0-3.086,1.884-4.767,4.638-4.767c1.32,0,2.452,0.099,2.782,0.142v3.225l-1.91,0.001c-1.497,0-1.786,0.712-1.786,1.756v2.302
      h3.572l-0.467,3.606h-3.105v9.254h6.089c0.729,0,1.32-0.591,1.32-1.318V1.318C23.894,0.59,23.304,0,22.575,0z"/>
  </Icon>
);

export default Facebook;



// WEBPACK FOOTER //
// ./src/core/icons/components/social/Facebook.jsx